import { render, staticRenderFns } from "./SettingsTechnicalWork.vue?vue&type=template&id=6552645a&scoped=true&"
import script from "./SettingsTechnicalWork.vue?vue&type=script&lang=js&"
export * from "./SettingsTechnicalWork.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTechnicalWork.vue?vue&type=style&index=0&id=6552645a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6552645a",
  null
  
)

export default component.exports